const SearchIcon = () => {
  return (
    <svg width="65" height="64" viewBox="0 0 65 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="29.5" cy="28" r="25" stroke="#DFE3E8" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="47.5" y="43" width="24" height="6" rx="3" transform="rotate(45 47.5 43)" fill="#DFE3E8" />
    </svg>
  )
}
export default SearchIcon
